import React from "react";
import moment from "moment";
import cx from "classnames";
import ReactSVG from "react-svg";

import Loader from "../Loader";

import { convertHistoryFilters, getHistoryItemComponent, highlight, getAuthorName } from "./utils";

const HistoryContent = props => {
    const { t, isLoading, history, query } = props;

    const renderHistoryItem = ({ type, orderDate, item }, index) => {
        const isComment = item.contentType === "comment";
        const ItemComponent = getHistoryItemComponent(isComment ? item.contentType : type);
        if (ItemComponent) {
            return (
                <ItemComponent
                    orderDate={orderDate}
                    data={item}
                    key={index}
                    highlight={text => highlight(text, query)}
                />
            );
        } else {
            throw new Error(`Unknown type of history item. Type: [${type}]`);
        }
    };

    const renderHistoryGroup = ([orderDate, items]) => {
        const formattedDate = moment(parseInt(orderDate)).format("DD.MM.YYYY в HH:mm:ss");
        const checkCollection = true;

        const icon = getAuthorName(items) !== t("systemMessage") ? "user" : "system";

        const isChange = items && Array.isArray(items) && items.some(item => item.type === "change");
        const isCall = items && Array.isArray(items) && items.some(item => item.type === "call");
        const changeItemType = isChange && !isCall && t("history.change");

        return (
            <div className="history-items" key={orderDate}>
                <div className="history-item-content">
                    <header className="history-item-content__header">
                        <div className="history-name">
                            <ReactSVG className="author-icon" src={`/data/svg/history/${icon}.svg`} />
                            <div className="author-name">{highlight(getAuthorName(items, checkCollection), query)}</div>
                        </div>
                        <div className="history-date">{formattedDate}</div>
                    </header>
                    {changeItemType && <div className="history-change-item-type">{changeItemType}</div>}
                    <div className="history-item-list">{items.map(renderHistoryItem)}</div>
                </div>
            </div>
        );
    };
    return (
        <div className={cx("history-tab__content")}>
            {isLoading && <Loader />}
            {Object.entries(history).map(renderHistoryGroup)}
        </div>
    );
};

export default HistoryContent;
